export const ColumnIds = {
  name: "name",
  baseCertificationNames: "baseCertificationNames",
  displayOrder: "displayOrder",
} as const;
